export default{
    setAirports(state,payload){
        state.airports = payload;
    },
    setPrintLang(state,payload){
        state.printLang = payload;
    }
}